// A static map preview uses asset HTTP requests only; it never joins a server.
export function mountMapEmbed({ canvas, status, retry, map, createRenderer, createLoader, fetchDetails, onDiagnostic = () => {} }) {
    let renderer, loader, abort, generation = 0, disposed = false;
    const show = text => { status.textContent = text; };
    const fail = error => {
        if (disposed || error?.name === 'AbortError') return;
        onDiagnostic(error?.message ?? 'Map preview unavailable');
        show(error?.status === 404
            ? 'This map is not available for preview yet.'
            : 'Map preview unavailable. Retry or open this map in Explorer.');
        retry.hidden = false;
    };
    const load = async () => {
        const own = ++generation;
        abort?.abort(); loader?.cancel();
        abort = new AbortController();
        retry.hidden = true;
        show('Loading map…');
        try {
            const details = await fetchDetails(map, abort.signal);
            if (disposed || own !== generation) return;
            await loader.load(details, { signal: abort.signal });
            if (!disposed && own === generation) show('Click the map to fly around · WASD to move · Esc to release');
        } catch (error) { if (own === generation) fail(error); }
    };
    try {
        renderer = createRenderer();
        loader = createLoader(renderer, show, fail);
        void load();
    } catch (error) {
        onDiagnostic(error?.message ?? 'Map preview unavailable in this browser');
        renderer?.dispose(); renderer = null;
        show('Map preview unavailable in this browser. WebGL 2 graphics support is required.');
    }
    const lost = event => {
        event.preventDefault(); generation++; abort?.abort(); loader?.cancel();
        show('Graphics context lost. Waiting for recovery…'); retry.hidden = true;
    };
    const restored = () => { if (!disposed && loader) void load(); };
    retry.addEventListener('click', restored);
    canvas.addEventListener('webglcontextlost', lost);
    canvas.addEventListener('webglcontextrestored', restored);
    return {
        dispose() {
            if (disposed) return;
            disposed = true; generation++; abort?.abort(); loader?.dispose(); renderer?.dispose();
            retry.removeEventListener('click', restored);
            canvas.removeEventListener('webglcontextlost', lost);
            canvas.removeEventListener('webglcontextrestored', restored);
        },
    };
}
